module.exports = __webpack_public_path__ + "static/benefit-bf7132746c963292d52aa7859d5b97e6.svg";